"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CONTENTLANGUAGES_HASH = void 0;
exports.GET_CONTENTLANGUAGES_HASH = `
  {
    contentLanguages
  }
`;
//# sourceMappingURL=contentLanguages-queries.js.map